import React from 'react'

class UpdatePlan extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      title: this.props.title,
      description: this.props.description,
      sendReminders: this.props.sendReminders,
      error: '',
    }
    this.handleChangeTitle = this.handleChangeTitle.bind(this)
    this.handleChangeDescription = this.handleChangeDescription.bind(this)
    this.handleChangeSendReminders = this.handleChangeSendReminders.bind(this)
  }

  handleChangeTitle(e) {
    this.setState({ title: e.target.value })
  }

  handleChangeDescription(e) {
    this.setState({ description: e.target.value })
  }

  handleChangeSendReminders(e) {
    this.setState({ sendReminders: e.target.checked })
  }

  render() {
    return (
      <>
        <div className="uk-margin">
          <label className="uk-form-label">Title</label>
          <div className="uk-form-controls">
            <input
              className="uk-input"
              type="text"
              placeholder=""
              value={this.state.title}
              onChange={this.handleChangeTitle}
            />
          </div>
        </div>

        <div className="uk-margin">
          <label className="uk-form-label">Description</label>
          <div className="uk-form-controls">
            <input
              className="uk-input"
              type="text"
              placeholder=""
              value={this.state.description}
              onChange={this.handleChangeDescription}
            />
          </div>
        </div>
        <div className="uk-margin">
          <div className="uk-form-controls">
            <input
              className="uk-checkbox"
              type="checkbox"
              checked={this.state.sendReminders}
              onChange={this.handleChangeSendReminders}
              style={{ marginRight: 10 }}
            />
            Send Reminders
            <a
              href="#"
              data-uk-icon="icon: info; ratio: 0.8"
              data-uk-toggle="target: #modal-send-reminders"
              style={{ marginLeft: 8 }}
            />
          </div>
          <small className="uk-text-danger">{this.state.error}</small>
        </div>
      </>
    )
  }
}

export default UpdatePlan
